import Connection from './net';
import Graphics from './graphics';

import * as types from 'shrike-client';
import wasm from '../../wasm';

export default class State {
    private renderPtr?: number;
    private graphics: Graphics;
    private conn?: Connection;
    private interpreterState?: number; // ptr
    private interpreter?: typeof types;

    constructor(root: HTMLElement, width: number, height: number) {
        this.graphics = new Graphics(root, width, height);
    }

    public resize(width: number, height: number) {
        this.graphics.resize(width, height);
    }

    public runCmd(cmd: types.ClientCmd) {
        switch (cmd.tag) {
            case 'ClientCmdNone':
                return;
            case 'Tmp':
                throw new Error('`Tmp` is invalid cmd!');
            case 'ClientCmdBatch':
                const cmds = cmd.fields as types.ClientCmd[];
                for (const subCmd of cmds) {
                    this.runCmd(subCmd);
                }
                return;
            case 'ClientCmdDownloadFile':
                // console.log('downloading...');
                const filename = cmd.fields[0] as string;
                const contents = cmd.fields[1] as string;

                const element = document.createElement('a');
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(contents));
                element.setAttribute('download', filename);
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
                return;
             case 'ClientCmdGetUnixTimeMs':
                 throw new Error('`ClientCmdGetUnixTimeMs` is unsupported!');
             default:
                 throw new Error('Invalid ClientCmd:' + (cmd as any));
        }
    }

    public update(clientmsgPtr: number) {
        const interpreter = this.interpreter!!;
        const interpreterState = this.interpreterState!!;

        const updateResponse = interpreter.update(interpreterState, clientmsgPtr) as types.UpdateResponse;
        const cmd = updateResponse.cmd as types.ClientCmd; // TODO do something with this
        this.runCmd(cmd);

        if (updateResponse.send_server_msg) {
            this.conn!!.sendEvent(updateResponse.serialized_server_msg);
        }
    }

    public handleGraphicsEvent(event: types.Event) {
        const interpreter = this.interpreter!!;
        const clientmsgPtr = interpreter.render_event(this.renderPtr!!, event);
        this.update(clientmsgPtr);
        this.render();
    }

    public render() {
        const interpreter = this.interpreter!!;
        const interpreterState = this.interpreterState!!;

        if (this.renderPtr) {
            interpreter.free_render(this.renderPtr);
        }

        this.renderPtr = interpreter.render(interpreterState);

        const rendered = interpreter.render_to_js(this.renderPtr) as types.Graphics;
        this.graphics.render(rendered, (event: types.Event) => this.handleGraphicsEvent(event));
    }

    public start(authToken: Promise<string>) {
        this.conn = new Connection(authToken, async (substate) => {
            const interpreter = await wasm;
            this.interpreter = interpreter;

            if (!this.interpreterState) {
                const conn = this.conn!!;
                this.interpreterState = interpreter.new_state(conn.clientId!!, conn.serializedClient!!, substate);
                const initCmd = interpreter.init(this.interpreterState) as types.ClientCmd; // TODO do something
                this.runCmd(initCmd);
            } else {
                interpreter.set_server_state(this.interpreterState, substate);
            }
            this.render();
        });
    }

    public stop() {
        this.conn!!.close();
    }
}
